<template>
    <div class="search">
        <input type="text" class="search-input" placeholder="Søg efter spiller.."
               list="names"
               v-model="searchQuery"
               @keypress="keypressEvent()"
               @keypress.enter="goToUserPage()">

        <datalist v-if="autoCompleteLoaded" id="names">
            <option v-for="(item,i) in autoCompleteResults" :key="i" :value="item.name"></option>
        </datalist>

        <div class="input-group-append">
            <router-link :to="{name:'mc_user', params: {username: searchQuery, page: 1}}" class="search-btn">Søg
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                autoCompleteLoaded: false,
                autoCompleteResults: [],
                searchQuery: "",
            }
        },
        methods: {
            keypressEvent() {
                this.autoCompleteLoaded = false
                if (this.searchQuery.length > 2) {
                    this.$api.getAutoComplete(this.searchQuery).then(res => {
                        this.autoCompleteResults = res;
                        this.autoCompleteLoaded = true;
                    }).catch(ignored => {
                        this.autoCompleteResults = [];
                        this.autoCompleteLoaded = false;
                    });
                } else {
                    this.autoCompleteResults = [];
                    this.autoCompleteLoaded = false;
                }
            },
            goToUserPage() {
                this.$router.push({name: 'mc_user', params: {username: this.searchQuery, page: 1}})
            }

        }
    }
</script>

<style lang="scss" scoped>
    .search {
        padding-top: 37px;
        width: 75%;
        margin-bottom: 1rem;
        display: flex;

        .search-input {
            border-top-left-radius: .25rem;
            border-bottom-left-radius: .25rem;
            background-color: #40444b;
            color: #a0a6b1;
            border: 1px solid #40444b;
            display: block;
            padding: .3rem .75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            font-family: inherit;
            outline: none;
        }

        .search-btn {
            color: #6c757d;
            text-decoration: none;
            background: #262a2d;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            user-select: none;
            padding: .375rem .75rem;
            font-size: 1rem;
            line-height: 1.5;
            border-top-right-radius: .25rem;
            border-bottom-right-radius: .25rem;

            &:hover {
                background: #2e3235;
                border: none;
                color: #6c757d;
            }
        }
    }

    @media screen and (max-width: 1400px) {
    }

    @media screen and (max-width: 990px) {
        .search {
            width: 75%;
            .search-input {
                width: 100%;
            }
        }
    }

    @media screen and (max-width: 760px) {
        .search {
            width: 100%;
            .search-input {
                width: 100%;
            }
        }
    }

    @media screen and (max-width: 585px) {
    }
</style>